import {
  AddressAutocomplete,
  AutocompleteSizes,
} from '@doordash/component-address-autocomplete'
import Button from '@doordash/component-button'
import { ErrorMessage } from '@doordash/component-fields'
import { CountryCode } from '@doordash/lib-i18n'
import * as React from 'react'
import { connect } from 'react-redux'

import { Text, StackChildren } from '@doordash/design-language'

import * as actions from '../../../../actions'
import * as events from '../../../../events'
import * as DA from '../../../../typeModules/events'

import { GoogleAddress } from '../../../../models/types'
import t from './strings'
import { COUNTRY_SHORTCODES } from '../../../../constants'

type Props = {
  goToNextStep: () => void
  onSubmit?: () => Promise<any>
  returnLink?: () => void
  updatePaymentAccount?: (paymentAccountId, payload) => Promise<any>
  paymentAccountId?: string
  trackBankAdditionalVerification?: (
    data: DA.BankAdditionalVerification
  ) => Promise<any>
  country?: CountryCode
}

type State = {
  selectedAddress: object
  isLoading: boolean
  error: string
}

export class VerifyAddress extends React.Component<Props, State> {
  public state = {
    selectedAddress: null,
    isLoading: false,
    error: null,
  }

  public componentDidMount() {
    const { trackBankAdditionalVerification, country } = this.props

    trackBankAdditionalVerification({
      country: COUNTRY_SHORTCODES[country],
      action: DA.EventActions.Rendered,
      name: DA.BankAdditionalVerificationPages.VerifyAddress,
    })
  }

  public handleAddressSelect = (address: GoogleAddress) => {
    const { trackBankAdditionalVerification, country } = this.props

    const payload = {
      address: {
        line1: address.street,
        city: address.city,
        postal_code: address.zipCode,
        state: address.state,
      },
    }

    trackBankAdditionalVerification({
      country: COUNTRY_SHORTCODES[country],
      action: DA.EventActions.Clicked,
      name: 'handle_address_select',
    })

    this.setState({
      selectedAddress: payload,
      error: null,
    })
  }

  public handleSubmit = async () => {
    const {
      updatePaymentAccount,
      paymentAccountId,
      goToNextStep,
      trackBankAdditionalVerification,
      country,
    } = this.props
    const { selectedAddress } = this.state

    if (!selectedAddress) {
      this.setState({
        error: t.addressError(),
      })
      return
    }

    this.setState({
      isLoading: true,
    })

    try {
      await updatePaymentAccount(paymentAccountId, selectedAddress)

      trackBankAdditionalVerification({
        country: COUNTRY_SHORTCODES[country],
        action: DA.EventActions.Submit,
        name: DA.BankAdditionalVerificationPages.VerifyAddress,
      })
    } catch (e) {
      this.setState({
        isLoading: false,
      })

      trackBankAdditionalVerification({
        country: COUNTRY_SHORTCODES[country],
        action: DA.EventActions.Error,
        name: DA.BankAdditionalVerificationPages.VerifyAddress,
      })

      return
    }

    goToNextStep()
  }

  public render() {
    const { isLoading, error } = this.state
    return (
      <React.Fragment>
        <StackChildren>
          <Text
            styles={Text.Styles.PageTitle}
            textAlign={Text.TextAlignments.Center}
          >
            {t.title()}
          </Text>
          <AddressAutocomplete
            placeholder={t.searchPlaceholder()}
            initialInputValue={''}
            onSelect={this.handleAddressSelect}
            autocompleteSize={AutocompleteSizes.Small}
          />
          {error && <ErrorMessage error={error} />}
          <Button
            onClick={this.handleSubmit}
            type={Button.Types.Primary}
            state={isLoading ? Button.States.Loading : Button.States.Default}
          >
            {t.primaryAction()}
          </Button>
        </StackChildren>
      </React.Fragment>
    )
  }
}

const mapStateToProps = state => ({
  country: state.application.country,
  paymentAccountId: state.paymentAccount.id,
})

const mapDispatchToProps = {
  trackBankAdditionalVerification: events.trackBankAdditionalVerification,
  updatePaymentAccount: actions.updatePaymentAccount,
}

export default connect(mapStateToProps, mapDispatchToProps)(VerifyAddress)
